var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"hideHeading"},[_vm._v("很高興見到你，歡迎回來STEP1NE")]),_vm._v(" "),_c('DashBoardWrapper',{attrs:{"menu":_vm.menu}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }